import React from "react";
import QuickFilter from "../../Common/QuickFilter";

const ShipmentQuickFilter = (props) => (
  <QuickFilter filterName={"ShipmentManagementFilter"} isStoreEvent {...props} />
);


export default ShipmentQuickFilter